/**
 * Navbar hover indicator, two looks (header setting "Menu hover effect"):
 * - underline (option D from the motion previews): one glowing brand line
 *   under the items that stretches and slides to the hovered one;
 * - pill (option B): a soft brand capsule behind the hovered item.
 * Same element and same motion either way; only the CSS differs.
 *
 * One soft brand capsule sits behind the desktop menu and glides to the
 * item under the pointer (or keyboard focus) with a small spring, stays on
 * the item whose panel is open, and fades out when the pointer leaves an
 * idle menu. It is one absolutely-positioned element moved with transform
 * and width, so nothing in the row reflows.
 *
 * Desktop only (the list is hidden on mobile). Reduced motion keeps the
 * pill but drops the glide (section-header.css).
 */
(function () {
  function setup(list) {
    if (list.dataset.deco) return;
    list.dataset.deco = 'true';
    var nav = list.closest('[data-menu-hover]');
    var style = (nav && nav.getAttribute('data-menu-hover')) || 'underline';
    list.classList.add(style === 'pill' ? 'has-nav-pill' : 'has-nav-line');

    var pill = document.createElement('span');
    pill.className = 'header__menu-pill';
    pill.setAttribute('aria-hidden', 'true');
    list.insertBefore(pill, list.firstChild);

    var PAD = style === 'pill' ? 14 : 0;

    function moveTo(item) {
      var link = item.querySelector('.header__menu-link');
      if (!link) return;
      var lb = list.getBoundingClientRect();
      var ib = link.getBoundingClientRect();
      pill.style.width = ib.width + PAD * 2 + 'px';
      pill.style.transform = 'translateX(' + (ib.left - lb.left - PAD) + 'px)';
      if (!pill.classList.contains('is-on')) {
        // Appear in place rather than sliding in from the left edge.
        pill.classList.add('is-snap');
        void pill.offsetWidth;
        pill.classList.remove('is-snap');
      }
      pill.classList.add('is-on');
    }

    function openItem() {
      var open = list.querySelector('.header__menu-details[open]');
      return open ? open.closest('.header__menu-item') : null;
    }

    function settle() {
      var open = openItem();
      if (open) moveTo(open);
      else pill.classList.remove('is-on');
    }

    list.querySelectorAll('.header__menu-item').forEach(function (item) {
      item.addEventListener('pointerenter', function () { moveTo(item); });
      item.addEventListener('focusin', function () { moveTo(item); });
    });
    list.addEventListener('pointerleave', settle);
    list.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!list.contains(document.activeElement)) settle();
      }, 0);
    });
    list.addEventListener('toggle', function () {
      window.setTimeout(function () {
        if (!list.matches(':hover')) settle();
      }, 0);
    }, true);
  }

  function init() {
    document.querySelectorAll('.header__nav .header__menu-list').forEach(setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
